import type { Venue } from '@Types/venue';
import type { MatrixCellState } from '../MatrixCell';

const required = (pass: boolean, tooltip: string): MatrixCellState =>
  pass ? { kind: 'pass', tooltip } : { kind: 'fail', tooltip };

const optional = (set: boolean, tooltip: string): MatrixCellState =>
  set
    ? { kind: 'optional-set', tooltip }
    : { kind: 'optional-missing', tooltip: tooltip || 'Not set' };

export const TE_REQUIRED_LABELS = [
  'Venue Enabled',
  'Toast Restaurant',
  'TE Menu',
  'TE Dining Option',
] as const;

export const TE_OPTIONAL_LABELS = ['TE Service Charge'] as const;

export type TicketedEventsEvaluation = {
  on: boolean;
  required: MatrixCellState[];
  optional: MatrixCellState[];
};

export function evaluateTicketedEventsForVenue(
  venue: Venue,
): TicketedEventsEvaluation {
  const reqs: MatrixCellState[] = [
    required(
      venue.disabledAt === null,
      venue.disabledAt === null
        ? 'Venue is enabled'
        : `Disabled at ${venue.disabledAt}`,
    ),
    required(
      venue.toastRestaurantGuid != null,
      venue.toastRestaurantGuid ?? 'Missing',
    ),
    required(
      venue.toastTicketedEventMenuGuid != null,
      venue.toastTicketedEventMenuGuid ?? 'Missing',
    ),
    required(
      venue.toastTicketedEventDiningOptionGuid != null,
      venue.toastTicketedEventDiningOptionGuid ?? 'Missing',
    ),
  ];
  const serviceChargeSet = venue.toastTicketedEventServiceChargeGuid != null;
  return {
    on: reqs.every((c) => c.kind === 'pass'),
    required: reqs,
    optional: [
      optional(
        serviceChargeSet,
        venue.toastTicketedEventServiceChargeGuid ?? 'Not set',
      ),
    ],
  };
}
